<template>
  <div class="checklist-container">
    <router-link
      :to="upNextRoute"
      @click="selectChecklistItem"
    >
      <div class="display-text">
        <span>Next Up:</span>
        <p v-if="nextUpChecklistItem">
          {{ nextUpChecklistItem.displayName }}
        </p>
      </div>
      <router-link
        :to="checklistRoute"
        class="checklist-router-link"
        @click="accessChecklist"
      >
        <icon
          class="list-bullet-icon"
          name="list-bullet"
          variant="ffffff"
        />
      </router-link>
    </router-link>
    <!-- <div class="progress">
      <div
        class="bar"
        :style="{ width: progressWidth }"
      />
    </div> -->
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import { getActiveCompletedChecklistItemIds } from '@/utils/checklist';
import ChecklistMixin from '@/mixins/checklist';

export default {
  components: { Icon },
  mixins: [ChecklistMixin],
  props: {
    checklist: {
      type: Object,
    },
    dashboard: {
      type: Object,
    },
  },
  computed: {
    checklistItems() {
      return this.checklist?.checklistItems || [];
    },
    completedChecklistItemIds() {
      if (this.checklist) {
        if (this.checklistState) {
          return getActiveCompletedChecklistItemIds(this.checklist, this.checklistState);
        } else {
          return [];
        }
      }

      return [];
    },
    checklistRoute() {
      return { name: 'checklist#show', params: { checklistId: this.checklist?.id }};
    },
    checklistState() {
      return this.$store.getters['checklistStates/get'][this.checklist.id];
    },
    // progressWidth() {
    //   const percent = (this.completedChecklistItemIds.length / this.checklistItems.length) * 100;
    //   return `${percent}%`;
    // },
    incompleteChecklistItems() {
      return this.checklistItems
        .filter(item => !this.completedChecklistItemIds.includes(item.id))
        .sort((a, b) => a.sortOrder - b.sortOrder);
    },
    nextUpChecklistItem() {
      if (this.checklist && this.checklistState) {
        return this.incompleteChecklistItems[0];
      }
    },
    upNextRoute() {
      if (this.nextUpChecklistItem) {
        return this.checklistItemRoute(this.nextUpChecklistItem);
      }
    },
  },
  methods: {
    accessChecklist() {
      this.$analytics.events.accessedChecklist({ sourceType: 'dashboard', sourceId: this.dashboard.id });
    },
    selectChecklistItem() {
      const navItem = this.$store.getters['navigationItems/navigationItems'][this.nextUpChecklistItem.navigationItemId];
      this.$analytics.events.selectedChecklistItem({ name: this.nextUpChecklistItem.displayName, destinationType: navItem?.destination, destinationId: navItem?.resourceId });
    },
  },
};
</script>

<style lang="scss" scoped>
.checklist-container {
  background: #001c74;
  display: block;
  width: calc(100% + 96px);
  border-bottom: 1px solid #cecece;
  margin-top: rem-calc(-32);
  margin-bottom: rem-calc(32);

  @include breakpoint(small) {
    margin-bottom: rem-calc(16);
    margin-top: rem-calc(-32);
    width: calc(100% + 32px);
  }

  > a {
    align-items: center;
    box-sizing: border-box;
    color: white;
    display: flex;
    font-size: rem-calc(14);
    font-weight: $semi-bold;
    width: 100%;
    padding: rem-calc(16) rem-calc(48);

    @include breakpoint(small) {
      padding: rem-calc(16);
    }

    .display-text {
      flex: 1;
      span {
        font-size: rem-calc(12);
        line-height: rem-calc(20);
        color: #FFE980;
      }
      p {
        margin: 0;
        font-weight: $bold;
        font-size: rem-calc(14);
        line-height: rem-calc(16);
      }
    }
  }

  // .progress {
  //   height: 4px;
  //   width: 100%;

  //   .bar {
  //     background-color: #00d8f8;
  //     height: 100%;
  //     width: 20%;
  //   }
  // }

}
</style>
